<template>
  <md-dialog :md-active.sync="show" :md-click-outside-to-close="false" :md-esc-to-close="false">
    <md-dialog-title>{{ options.Lang.select_lang }}</md-dialog-title>

    <md-dialog-content >
      <md-field>
        <label for="language" class="pb-10">{{ options.Lang.Sprache }}</label>
        <md-select v-model="selectedLang" name="language" id="language" class="">
          <md-option v-for="lang in languages.filter(l => l !== 'en')" :key="lang" :value="lang"   :disabled="usedLangCodes.includes(lang)">
            {{ options.Lang.lang_code[lang] }}
          </md-option>
        </md-select>
      </md-field>
    </md-dialog-content>
    <md-dialog-actions class="pb-20">
      <md-button class="md-raised md-primary"@click="$emit('update:show', false)">{{ options.Lang.Abbrechen }}</md-button>
      <md-button class="md-raised md-primary" @click="createTab">{{ options.Lang.add_lang }}</md-button>
    </md-dialog-actions>
  </md-dialog>
</template>

<script>
export default {
  name: 'AddLanguageModal',
  props: {
    show: {},
    languages: {},
    options:{},
    brandingLangs: [],

  },
  data() {
    return {
      selectedLang: ''
    };
  },
  computed: {
    usedLangCodes() {
      return this.brandingLangs.map(lang => lang.lang_code);
    }
  },
  methods: {
    createTab() {
      const data = {
        lang_code: this.selectedLang,
        brand_id: this.options.brand_id,
        user_id: this.options.user.id,
      }
      this.doPost({data}, "branding/languages/createTab" , (res) => {
        this.$emit('close');
      })

    }
  },
  watch: {
    show(val) {
      if (!val) this.selectedLang = '';
    }
  }
};
</script>

<style scoped>
.md-dialog-title {
  text-align: center;
  font-weight: bold;
}
.md-dialog {
  max-width: 500px;
  width: 100%;
  margin: auto;
}
.md-dialog-actions {
  justify-content: center;
}
.md-dialog-actions .md-button {
  margin-left: 30px;
  margin-right: 30px;
}
.md-field.md-focused label,
.md-field.md-has-value label {
  padding-top: 5px;
}
.md-field label {
  padding-top: 0px; /* reset when not floating */
}

</style>
